import { LazyLoader, Modal } from '@bp/ui-components';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DeputateLessonForm } from '../Forms/DeputateLessonForm';
import { LessonFormType } from '../types';

type DeputateLessonModalProps = {
  lessonUuid: string | null;
  isOpen: boolean;
  onClose: () => void;
  defaultInitialValues?: Partial<LessonFormType>;
};

export const DeputateLessonModal = ({
  lessonUuid,
  isOpen,
  onClose,
  defaultInitialValues,
}: DeputateLessonModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      title={lessonUuid ? t('lesson.edit') : t('lesson.add')}
      loading={loading}
      isOpen={isOpen}
      onRequestClose={onClose}
    >
      <Suspense fallback={<LazyLoader embedded forceHeight='40vh' />}>
        <DeputateLessonForm
          lessonUuid={lessonUuid}
          defaultInitialValues={{ ...defaultInitialValues, timetableEnabled: true }}
          onLoad={setLoading}
          onClose={onClose}
        />
      </Suspense>
    </Modal>
  );
};
